var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 67,
    viewBox: "0 0 48 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6496 34.6972C31.5305 34.6972 37.1086 29.1192 37.1086 22.2383C37.1086 15.3574 31.5305 9.7793 24.6496 9.7793C17.7687 9.7793 12.1907 15.3574 12.1907 22.2383C12.1907 29.1192 17.7687 34.6972 24.6496 34.6972Z",
    fill: "#FCC240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8695 22.3308C45.8695 24.4215 41.7641 25.8312 41.152 27.716C40.5188 29.6694 42.9883 33.2226 41.8063 34.8487C40.6138 36.4907 36.4609 35.2341 34.8198 36.4273C33.1946 37.61 33.1154 41.9551 31.163 42.5886C29.2792 43.2011 26.6724 39.7535 24.5828 39.7535C22.4932 39.7535 19.8864 43.2011 18.0026 42.5886C16.0502 41.9551 15.9711 37.61 14.3458 36.4273C12.7047 35.2341 8.55185 36.4907 7.35929 34.8487C6.17728 33.2226 8.64683 29.6694 8.01362 27.716C7.4015 25.8312 3.29614 24.4162 3.29614 22.3308C3.29614 20.2453 7.4015 18.8304 8.01362 16.9456C8.64683 14.9921 6.17728 11.4389 7.35929 9.81281C8.55185 8.17085 12.7047 9.4274 14.3458 8.23421C15.9711 7.05157 16.0502 2.70645 18.0026 2.0729C19.8864 1.46047 22.4932 4.90805 24.5828 4.90805C26.6724 4.90805 29.2792 1.46047 31.163 2.0729C33.1154 2.70645 33.1946 7.05157 34.8198 8.23421C36.4609 9.4274 40.6138 8.17085 41.8063 9.81281C42.9883 11.4389 40.5188 14.9921 41.152 16.9456C41.7588 18.8251 45.8695 20.24 45.8695 22.3308Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2502 43.4806L33.1733 63.8757C33.7696 65.2379 35.6165 65.391 36.0756 64.1186L37.5478 59.2244C37.8328 58.4272 38.7509 58.1157 39.5741 58.5381L44.3813 61.2571C45.6952 61.9276 46.9405 60.7397 46.3495 59.3828L35.9806 35.6826",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7384 40.0805L15.3272 63.8757C14.731 65.2379 12.8841 65.391 12.425 64.1186L10.9528 59.2244C10.6678 58.4272 9.74965 58.1157 8.92647 58.5381L4.11929 61.2571C2.80537 61.9276 1.56004 60.7397 2.15104 59.3828L12.5253 35.6826",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.9f5b9150cc337fa97e0e8e24a6fc2109.svg";
export { ForwardRef as ReactComponent };